var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 798.36 585.03",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m578 545.5h-507.82c-33.51 0-60.68-27.17-60.68-60.68v-387.64c0-33.51 27.17-60.68 60.68-60.68",
    fill: "none",
    stroke: "#041f3f",
    strokeMiterlimit: 10,
    strokeWidth: 19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m679.99 545.36c-1.38.09-2.77.14-4.17.14",
    fill: "none",
    stroke: "#041f3f",
    strokeMiterlimit: 10,
    strokeWidth: 19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m189 36.5h486.82c33.51 0 60.68 27.17 60.68 60.68v134.32l48.01 52.98c5.7 6.29 5.81 15.85.25 22.26l-48.27 55.76v122.32c0 32.11-24.94 58.4-56.51 60.54",
    fill: "none",
    stroke: "#041f3f",
    strokeMiterlimit: 10,
    strokeWidth: 19
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#041f3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.21 0s-30.21 16-30.21 50c0 14 10 20 17 20 0 0 17-1 17-17s-13.23-16.5-13.23-16.5.23-11.5 16.23-22.5c-3-6-6.79-14-6.79-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.24.17s-30.21 16-30.21 50c0 14 10 20 17 20 0 0 17-1 17-17s-13.23-16.5-13.23-16.5.23-11.5 16.23-22.5c-3-6-6.79-14-6.79-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.11 585.03s30.21-16 30.21-50c0-14-10-20-17-20 0 0-17 1-17 17s13.23 16.5 13.23 16.5-.23 11.5-16.23 22.5c3 6 6.79 14 6.79 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.46 584.98s30.21-16 30.21-50c0-14-10-20-17-20 0 0-17 1-17 17s13.23 16.5 13.23 16.5-.23 11.5-16.23 22.5c3 6 6.79 14 6.79 14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.376a48c8f191cecbd906c579feacb467.svg";
export { ForwardRef as ReactComponent };